import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { CardDetails as CreditCardDetailsProps, Brand, creditCardIconMapping } from './util';

import styles from './creditCardDetailsStyles.scss';

const CreditCardDetails: React.FC<CreditCardDetailsProps> = ({
  expiryMonth,
  expiryYear,
  lastFour,
  brand
}): React.ReactElement => {
  const formattedBrand = Brand[brand];
  const creditCardIcon = creditCardIconMapping[brand];
  const formattedExpiry = expiryMonth + '/' + expiryYear;

  return (
    <div>
      <div className={styles['credit-card-details']}>
        <FontAwesomeIcon icon={creditCardIcon} size="2x" className={styles['credit-card-icon']} />{' '}
        <span>
          <span className={styles['bold']}>{formattedBrand} </span>
          <span>
            ending in <span className={styles['bold']}>{lastFour}</span> Exp. {formattedExpiry}
          </span>
        </span>
      </div>
    </div>
  );
};

export default CreditCardDetails;
